import 'bootstrap/dist/css/bootstrap.min.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import React from 'react';
import 'antd/dist/antd.css';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Web3ReactProvider } from '@web3-react/core';
import {
  ExternalProvider,
  JsonRpcFetchFunc,
  Web3Provider,
} from '@ethersproject/providers';
import { GoogleOAuthProvider } from '@react-oauth/google';
import ErrorBoundary from './components/ErrorBoundary';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

function getLibrary(provider: ExternalProvider | JsonRpcFetchFunc) {
  return new Web3Provider(provider, 'any');
}

const recaptchaSiteKey = process.env.REACT_APP_GOOGLE_RECAPTCHA_KEY || '';

// Debug: Log reCAPTCHA key status
if (process.env.NODE_ENV === 'development') {
  console.log('🔐 reCAPTCHA Site Key loaded:', recaptchaSiteKey ? '✅ Yes' : '❌ No');
  if (!recaptchaSiteKey) {
    console.warn('⚠️ REACT_APP_GOOGLE_RECAPTCHA_KEY is not set in .env file');
  }
}

root.render(
  <ErrorBoundary>
    <GoogleOAuthProvider clientId="232957845996-ctig89g3o6uigoq4gu1pkil3fauv88gi.apps.googleusercontent.com">
    <GoogleReCaptchaProvider
      reCaptchaKey={recaptchaSiteKey}
      scriptProps={{
        async: false,
        defer: false,
        appendTo: 'head',
        nonce: undefined,
      }}
    >
      <React.StrictMode>
        <Web3ReactProvider getLibrary={getLibrary}>
          <App />
        </Web3ReactProvider>
      </React.StrictMode>
    </GoogleReCaptchaProvider>
  </GoogleOAuthProvider>
  </ErrorBoundary>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
